import type { OperationVariables } from '@apollo/react-common';
import { type GraphQLTaggedNode } from 'relay-runtime';

import {
	type MutationFunctionInterop,
	type UseMutationInteropSupportedArgs,
	type UseMutationInteropSupportedResult,
	useMutationInterop,
} from './useMutationInterop.ts';

export type MutationInteropProps<
	TData,
	TVariables extends Record<string, any> = OperationVariables,
> = {
	mutation: GraphQLTaggedNode;
	children: (
		mutateFunction: MutationFunctionInterop<TData, TVariables>,
		result: UseMutationInteropSupportedResult<TData, TVariables>[1],
	) => JSX.Element | null;
} & UseMutationInteropSupportedArgs<TData, TVariables>[1];

export function MutationInterop<
	TData = any,
	TVariables extends Record<string, any> = OperationVariables,
>({ children, mutation, ...props }: MutationInteropProps<TData, TVariables>): JSX.Element | null {
	const [mutate, result] = useMutationInterop<TData, TVariables>(mutation, props);
	return children(mutate, result);
}
